<template>
  <div class="login_container">
    <div class="login_wrapper">
      <div class="login_box">

      <!-- logo -->
      <div class="logo_area">
        <img src="../assets/logo.png" />
        <h2>EvaJudge</h2>
        <p>Jiangnan University · Sino–UK AI Lab</p>
      </div>

      <!-- 表单 -->
      <el-form
        ref="loginFormRef"
        :model="loginForm"
        :rules="loginRules"
        class="login_form"
        label-width="0px"
      >
        <el-form-item prop="email">
          <el-input
            v-model="loginForm.email"
            prefix-icon="iconfont icon-youxiang"
            placeholder="Email"
          />
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            prefix-icon="iconfont icon-mima"
            type="password"
            placeholder="Password"
            @keyup.enter.native="login"
          />
        </el-form-item>

        <el-form-item class="btns">
          <Vcode :show="isShow" @success="success" @close="close" />

          <el-button type="primary" class="login_btn" @click="login">
            Sign in
          </el-button>

          <div class="extra">
            <span @click="enroll">Create account</span>
            <span @click="resetLoginForm">Reset</span>
          </div>
        </el-form-item>
      </el-form>

      <div class="version">
          v{{ version }}
      </div>

    </div>


      <div class="affiliation-outside">
        An Efficient & Consistent Image Fusion Evaluation Platform

      </div>
    </div>
  </div>
</template>

<script>
import Vcode from "vue-puzzle-vcode";

export default {
  components: { Vcode },

  data() {
    return {
      version: __APP_VERSION__,
      loginForm: {
        email: "",
        password: "",
      },
      loginRules: {
        email: [
          { required: true, message: "Please enter your personal institution email", trigger: "blur" },
          { type: "email", message: "Please enter a valid institution email address", trigger: ["blur", "change"] }
        ],
        password: [
          { required: true, message: "Please enter your password", trigger: "blur" },
          { min: 8, max: 19, message: "Password must be 8 to 19 characters long", trigger: "blur" }
        ]
      },
      isShow: false
    };
  },
  created() {
    this.loginForm.email = this.$route.query.email || "";
  },

  methods: {
    resetLoginForm() {
      this.$refs.loginFormRef.resetFields();
    },

    enroll() {
      this.$router.push({ path: "/register" });
    },

    login() {
      this.isShow = true;
    },

    async success() {
      this.isShow = false;

      this.$refs.loginFormRef.validate(async valid => {
        if (!valid) return;

        try {
          const res = await this.$http.post("/login", this.loginForm);

          this.$message.success("Login successful");
          sessionStorage.setItem("user", JSON.stringify(res.data));
          this.$router.push("/home");

        } catch (err) {
          const data = err.response?.data;

            // ⭐ 如果是未激活
            if (data?.need_verify) {
              this.$message.warning("Please verify your email first");
          
              this.$router.push({
                path: "/verify-email",
                query: { email: data.email }   // ⭐ 带邮箱过去
              });

              return;
            }

            const msg = data?.msg || "Email or password incorrect";
            this.$message.error(msg);
                  }
      });
    },

    close() {
      this.isShow = false;
    }
  }
};
</script>

<style lang="less" scoped>

/* ===== 页面整体 ===== */
.login_container {
  height: 100%;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ===== 卡片 ===== */
.login_box {
  width: 380px;
  padding: 40px 40px 30px;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
}

/* ===== Logo区 ===== */
.logo_area {
  text-align: center;
  margin-bottom: 30px;

  img {
    width: 48px;
    margin-bottom: 10px;
  }

  h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #1f2a44;
  }

  p {
    margin-top: 6px;
    font-size: 13px;
    color: #6b7280;
  }
}

/* ===== 输入框 ===== */
.el-input__inner {
  border-radius: 6px;
}

/* ===== 按钮 ===== */
.login_btn {
  width: 100%;
  margin-top: 10px;
  border-radius: 6px;
  background: linear-gradient(90deg, #3fae9a, #6fd1c2);
  border: none;
}

/* ===== 底部操作 ===== */
.extra {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  font-size: 12px;
  color: #6b7280;

  span {
    cursor: pointer;
  }

  span:hover {
    color: #3fae9a;
  }
}

/* ===== 按钮区 ===== */
.btns {
  display: flex;
  flex-direction: column;
}

/* ===== 图标 ===== */
.iconfont {
  color: #9ca3af;
}

.version {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);   /* ⭐ 水平居中关键 */

  font-size: 13px;
  color: #9ca3af;
}

.login_box {
  position: relative;   /* ⭐ 必须加 */
}


.login_container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login_wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.affiliation-outside {
  margin-top: 12px;
  font-size: 13px;
  color: #9ca3af;
}

</style>